var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:['custom-button', _vm.classMap]},'component',_vm.attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.loading)?_c('CLoader'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }